function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var MyContributionFormBuilder = /*#__PURE__*/function () {
  function MyContributionFormBuilder() {
    _classCallCheck(this, MyContributionFormBuilder);
  }

  _createClass(MyContributionFormBuilder, null, [{
    key: "DrawForm",
    value: function DrawForm(container, data, labels) {
      // Loop over each dictionary item of <key, List<statementmodel>>
      for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        var keyTrimmed = key.replace(/\s/g, '');
        var dataContainer = document.createElement("div");
        dataContainer.classList.add("mppw-form-field__control");
        dataContainer.classList.add("mpp-mb-10"); // Set accounting name header

        var accountingNameLabel = document.createElement("h2");
        accountingNameLabel.classList.add("mpp-mt-0");
        accountingNameLabel.innerHTML = key;
        dataContainer.appendChild(accountingNameLabel);
        var statementDescription = document.createElement("p");
        statementDescription.innerHTML = labels.selectStatementYear;
        dataContainer.appendChild(statementDescription); // Build row of buttons div element

        var buttonRow = document.createElement("div");
        buttonRow.classList.add("mppw-row");
        var buttonCol = document.createElement("div");
        buttonCol.classList.add("mppw-col");
        var buttonGroupDiv = document.createElement("div");
        buttonGroupDiv.classList.add("mppw-btn-group");
        buttonGroupDiv.classList.add("mppw-btn-group-toggle");
        buttonGroupDiv.setAttribute("data-toggle", "buttons"); // Set active classes on the most recent statement year

        var mostRecentYear = Math.max.apply(Math, _toConsumableArray(value.map(function (o) {
          return o.statement_Year;
        })).concat([0]));
        var defaultFileUrl = ""; // Iterate over each object in the key

        var _iterator = _createForOfIteratorHelper(value),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var keyData = _step.value;
            var fileBaseUrl = keyData.fileBaseUrl; // Display my contribution buttons

            var buttonGroupLabel = document.createElement("label");
            buttonGroupLabel.setAttribute("data-accounting-group-label", keyTrimmed);
            buttonGroupLabel.classList.add("mppw-btn");
            buttonGroupLabel.classList.add("secondary");
            buttonGroupLabel.classList.add("mr-5");

            if (keyData.statement_Year === mostRecentYear) {
              buttonGroupLabel.classList.add("active");
              defaultFileUrl = "".concat(fileBaseUrl).concat(keyData.unique_Name);
            }

            buttonGroupLabel.innerHTML = "<input type=\"radio\" class=\"statement-year-button\" data-accounting-group=\"".concat(keyTrimmed, "\" data-file-url=\"").concat(fileBaseUrl).concat(keyData.unique_Name, "\" name=\"").concat(keyTrimmed, "_options\" id=\"").concat(keyData.unique_Name, "\" ").concat(keyData.statement_Year === mostRecentYear ? "checked" : "", "> ").concat(keyData.statement_Year);
            buttonGroupDiv.appendChild(buttonGroupLabel);
          } // Build save as pdf button

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var savePdfCol = document.createElement("div");
        savePdfCol.classList.add("mppw-col"); //<input type="button" class="mppw-btn mppw-btn-right primary" id="saveAsPDFButton" value="Save as PDF">

        var savePdfButton = document.createElement("input");
        savePdfButton.setAttribute("type", "button");
        savePdfButton.setAttribute("id", "saveAsPDFButton");
        savePdfButton.setAttribute("data-file-group", keyTrimmed);
        savePdfButton.setAttribute("data-file-url", defaultFileUrl);
        savePdfButton.value = labels.saveAsPdfButtonText;
        savePdfButton.classList.add("mppw-btn");
        savePdfButton.classList.add("mppw-btn-right");
        savePdfButton.classList.add("primary");
        savePdfButton.classList.add("save-as-pdf");
        savePdfCol.appendChild(savePdfButton); // Append elements

        buttonCol.appendChild(buttonGroupDiv);
        buttonRow.appendChild(buttonCol);
        buttonRow.appendChild(savePdfCol);
        dataContainer.appendChild(buttonRow);
        container.appendChild(dataContainer);
      }
    }
  }]);

  return MyContributionFormBuilder;
}();